
import React, { Fragment, useContext } from 'react'
import classnames from 'classnames'

import { CSSTransition, TransitionGroup } from '../React19Transition'
import { useThemeContext } from '../../contexts/ThemeProvider'
import HeaderLogo from '../Logos/HeaderLogo'
import CustomScrollbar from '../CustomScrollbar'
import VerticalNavWrapper from './VerticalNavWrapper'

const ApplicationSidebar = () =>
{
	const [controller, dispatch] = useThemeContext()
	const { backgroundColor, enableSidebarShadow } = controller
	
	return (
		<Fragment>
			<div className="sidebar-mobile-overlay" />
			<TransitionGroup>
				<CSSTransition
					component="div"
					className={ classnames("app-sidebar", backgroundColor, { "sidebar-shadow": enableSidebarShadow }) }
					appear={ true }
					enter={ false }
					exit={ false }
					timeout={ 500 }
				>
					<div>
						<HeaderLogo />
						<CustomScrollbar
							style={{
								height: 'calc(100vh - 80px)',
								maxHeight: 'calc(100vh - 80px)',
								overflowY: 'auto',
								overflowX: 'hidden',
								flex: 1
							}}
						>
							<div className="app-sidebar__inner">
								<VerticalNavWrapper />
							</div>
						</CustomScrollbar>
					</div>
				</CSSTransition>
			</TransitionGroup>
		</Fragment>
	)
}

export default ApplicationSidebar
